import { FC, PropsWithChildren } from 'react';
import { Paper } from '@mui/material';

// Style for Paper.
const paperStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: 3,
};

/**
 * Custom Paper Component.
 */
const CustomPaper: FC<PropsWithChildren<{height?: number}>> = ({ children, height = 400 }) => {
  return (
    <Paper
        variant="elevation"
        // elevation={2}
        sx={{...paperStyle, minHeight: height}}
    >
      {children}
    </Paper>
  )
}

export default CustomPaper;